export const GET_HASH_TAGS = 'GET_HASH_TAGS';
export const SET_HASH_TAGS = 'SET_HASH_TAGS';
export const ERROR_HASH_TAGS = 'ERROR_HASH_TAGS';